import { render, staticRenderFns } from "./LoyaltyCard.vue?vue&type=template&id=352f982a&"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports